/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateTitleHeaderWithoutConst } from "../../redux/sideBar";

function TitlePage({ name, ...other }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateTitleHeaderWithoutConst(name));
  }, []);

  return (
    <div className="title-page">
      <h1 className="bold white-space">{name}</h1>
    </div>
  );
}
export default TitlePage;
